import { Box, Paper, Typography } from '@mui/material';

import { TableTitleBox } from '../../../../common/components';

const AccessDeniedState = () => (
  <Box>
    <TableTitleBox title="Puntaje | Habitat 99" />
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: 3,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="h6" sx={{ mb: 1 }}>
        Acceso restringido
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Tu perfil no tiene habilitado el modulo Puntaje.
      </Typography>
    </Paper>
  </Box>
);

export default AccessDeniedState;
